module.exports = __webpack_public_path__ + "54a6be23751da23135758263065649e6.png";